import { AppSettings } from '@ukam/shell/config';

export const appSettings: AppSettings = {
  dir: 'ltr',
  theme: 'light',
  sidenavOpened: true,
  sidenavCollapsed: false,
  boxed: false,
  horizontal: false,
  cardBorder: true,
  activeTheme: 'ukam_theme',
  language: 'en-us',
  navPos: 'side',
  logoDark: './assets/images/logos/dark-logo.svg',
  logoLight: './assets/images/logos/light-logo.svg'
};
